import * as Yup from 'yup';

import { GoalTypes } from './constants';

export const goalSchema = Yup.object().shape({
  id: Yup.number(),
  goal_type: Yup.string(),
  is_maladaptive_correction: Yup.bool(),
  maladaptive_symptom_id: Yup.number().nullable(),
  goal_name_id: Yup.number().required(),
  goal_name: Yup.object({
    behavior_id: Yup.number().required(),
    label: Yup.string(),
  }).required(),
  measurement: Yup.object({
    comparand: Yup.number().nullable(),
    comparand_type: Yup.string().optional(),
    successful_attempts: Yup.number().nullable(),
    total_attempts: Yup.number().nullable(),
    duration_count: Yup.number().min(0).optional(),
    duration_unit: Yup.string().optional(),
  }).required(),
  status_at_creation: Yup.string(),
  date_introduced: Yup.string(),
  baseline_at_creation: Yup.string().nullable(),
  current_level_at_creation: Yup.string().nullable(),
  progress: Yup.number(),
  is_active: Yup.boolean().optional(),
  targets: Yup.array().min(1), // TODO: Update target schema
  description: Yup.string().when('goal_type', {
    is: GoalTypes.SkillAcquisition || GoalTypes.Caregiver,
    then: () => Yup.string().trim().required().min(10),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  operational_definition: Yup.string().when('goal_type', {
    is: GoalTypes.BehaviorReduction,
    then: () => Yup.string().trim().required().min(10),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  objective: Yup.string().when('goal_type', {
    is: GoalTypes.BehaviorReduction,
    then: () => Yup.string().trim().required().min(10),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  antecedent_modifications: Yup.string().when('goal_type', {
    is: GoalTypes.BehaviorReduction,
    then: () => Yup.string().trim().required().min(10),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  consequence_modifications: Yup.string().when('goal_type', {
    is: GoalTypes.BehaviorReduction,
    then: () => Yup.string().trim().required().min(10),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  target_mastery: Yup.number().when('goal_type', {
    is: GoalTypes.BehaviorReduction,
    then: () => Yup.number().required().positive(),
    otherwise: () => Yup.number().nullable().notRequired(),
  }),
  reason: Yup.string().optional(),
});
